/**
 * QueryString Context Selectors
 */

import { getLicenseUsagesFromQueryString } from '../../redux/helpers/license';
import { getLicenseComponents } from '../../redux/selectors/staticData';

import { filter, isEmpty } from 'lodash';
import { createSelector } from 'reselect';

import { IQueryStringContext } from './';
import { budgetFilterMaximum } from './budgetFilter';

const defaultList = [];

export const getAllSearchFilters = ({ filters }: IQueryStringContext) => filters;
export const getSearchQuery = ({ query }: IQueryStringContext) => query || '';
export const getTaxonomyQuery = ({ taxonomy_query }: IQueryStringContext) => taxonomy_query;
export const getSearchLicenseParams = ({ license_params }: IQueryStringContext) => license_params;

export const hasLicenseParams = createSelector(
  getSearchLicenseParams,
  (licenseParams) => !!licenseParams && licenseParams.length > 0,
);

export const getSearchFilters = createSelector(
  getAllSearchFilters,
  (filters) => filters && filters.term_filters ?
    filters.term_filters.map((name) => ({name}))
    : defaultList,
);

export const getBudgetFilter =
  createSelector<IQueryStringContext, GQL.ITrackSearchFilters | undefined, GQL.ITrackSearchBudgetFilter | undefined>(
  getAllSearchFilters,
  (filters) => !!filters ? filters.budget! : undefined,
);

export const getDefaultBudgetFilter =
  createSelector<IQueryStringContext, GQL.ITrackSearchFilters | undefined, GQL.ITrackSearchBudgetFilter>(
  getAllSearchFilters,
  (filters) => {
    return {
      maximum: filters && filters.budget ?
        (filters.budget!.maximum !== budgetFilterMaximum ?
          filters.budget!.maximum
          : null)
        : null,
      minimum: filters && filters.budget ? filters.budget.minimum : 0,
    };
  },
);

export const getTempoFilter = createSelector(
  getAllSearchFilters,
  (filters) => !!filters ? filters.tempo! : undefined,
);

export const getSimilarityFilter = createSelector(
  getAllSearchFilters,
  (filters) => !!filters ? filters.similarity! : undefined,
);

export const getExcludedSearchFilters = createSelector(
  getAllSearchFilters,
  (filters) => filters && filters.not_term_filters ?
    filters.not_term_filters.map((name) => ({ name }))
    : defaultList,
);

export const hasSearchFilters = createSelector(
  [getAllSearchFilters, getSearchQuery, getTaxonomyQuery, getSimilarityFilter],
  // tslint:disable-next-line:max-line-length
  (filters, query, taxonomyQuery, sim) => !!filter(filters, (f) => !isEmpty(f)).length || !!query || !!taxonomyQuery || !!sim,
);

export const hasInstrumentalFilter = createSelector(
  getSearchFilters,
  (filters) => filters.some((f) => f.name === 'Instrumental'),
);

interface IPropsWithLicenseParams {
  license_params?: GQL.ILicenseUsageParamsInput[];
}

const getLicenseParams = (_: IStoreState, { license_params }: IPropsWithLicenseParams) => license_params || defaultList;

export const licenseUsagesFromQueryStringSelector = createSelector(
  [getLicenseComponents, getLicenseParams],
  (components, params) => getLicenseUsagesFromQueryString({ components, params }),
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/queryString/selectors.ts